import { gridStoreResults } from 'fox-react/dist/components/FoxGrid/actions';
import gridNames from 'common/gridNames';
import RoutesManagementSrv from './RoutesManagementSrv';

export function storeResults(results) {
  return gridStoreResults(gridNames.routesManagement)(results);
}

export function getForGrid(dataState) {
  return function(dispatch) {
    return RoutesManagementSrv.getForGrid(dataState).then(results => {
      dispatch(storeResults(results));
    });
  };
}

export function addAsync(model) {
  return function() {
    return RoutesManagementSrv.add(model);
  };
}

export function updateAsync(model) {
  return function() {
    return RoutesManagementSrv.update(model);
  };
}
